import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { JobService } from 'src/app/core/services/job.service';
import { UploadProgress, BulkUploadSummary, FailedFile, ProcessedCandidate } from 'src/app/core/services/bulk-resume-upload.service';

@Component({
  selector: 'app-bulk-upload-resume-actions',
  templateUrl: './bulk-upload-resume-actions.component.html',
  styleUrls: ['./bulk-upload-resume-actions.component.css']
})
export class BulkUploadResumeActionsComponent implements OnInit {
  
  @Input() type: string; // 'progress' or 'summary'
  @Input() progress: UploadProgress;
  @Input() summary: BulkUploadSummary;
  @Output() onClose = new EventEmitter<any>();

  job: any;

  constructor(public bsModalRef: BsModalRef, private jobService: JobService) {}

  ngOnInit(): void {
    this.loadJob();
  }

  // Loose files are grouped under "Default Directory" internally; only real folder names are shown.
  get folderNames(): string {
    if (!this.summary || !this.summary.directoryName) { return ''; }
    return this.summary.directoryName.split(', ').filter(name => name !== 'Default Directory').join(', ');
  }

  get heading(): string {
    if (!this.job || !this.summary) { return ''; }
    const reqNumber = this.job.requisitionNumber || this.job.reqNumber;
    return `Bulk resume upload for <span class='emerald'>'${this.summary.totalFiles}'</span> resumes for `
      + `<span class='emerald'>'${this.job.title}'</span>`
      + (reqNumber ? ` (<span class='emerald'>'${reqNumber}'</span>)` : '')
      + ` at <span class='emerald'>'${this.summary.uploadedAt}'</span>`;
  }

  // The same modal turns from progress into summary, so the job is loaded when the summary arrives.
  loadJob(): void {
    if (this.job || !this.summary || !this.summary.jobId) { return; }
    this.jobService.getJob(this.summary.jobId, (job) => {
      this.job = job;
    }, () => { });
  }

  get progressPercentage(): number {
    if (this.progress) {
      return this.progress.progressPercentage || 0;
    }
    return 0;
  }

  get successPercentage(): number {
    if (this.summary && this.summary.totalFiles > 0) {
      return Math.round((this.summary.successfulFiles / this.summary.totalFiles) * 100);
    }
    return 0;
  }

  get candidates(): ProcessedCandidate[] {
    return this.summary && this.summary.candidates ? this.summary.candidates : [];
  }

  get failedFiles(): FailedFile[] {
    if (this.summary && this.summary.failedFilesList) {
      return this.summary.failedFilesList;
    }
    return [];
  }

  dismiss(): void {
    this.onClose.emit({ action: 'dismiss' });
    this.bsModalRef.hide();
  }

  close(): void {
    this.onClose.emit({ action: 'close' });
    this.bsModalRef.hide();
  }
}
